import React from 'react';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import DatePickerField from '../Formik/DatePickerField';
import { Submit } from '../Formik/Submit';
import { sharePlace } from '../../actions/parkingSpotActions';
import { useHistory } from 'react-router-dom';
import { SHARE_PLACE_DONE_ROUTE } from '../router/routes';

function SharePlacePage({ location }) {
  const place = location.state;
  const dispatch = useDispatch();
  const history = useHistory();
  const today = new Date();

  async function handleSubmit(values) {
    const reqData = {
      dateFrom: moment(values.dateFrom).format('DD.MM.YYYY'),
      dateTo: moment(values.dateTo).format('DD.MM.YYYY'),
      spotId: place.placeId
    };

    try {
      await dispatch(sharePlace(reqData));
      history.push(SHARE_PLACE_DONE_ROUTE);
    } catch (err) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error('Ups! Něco se nepovedlo, napište nám');
      }
    }
  }

  return (
    <div>
      <h2 className="text-center text-red">{place.place}</h2>
      <p className="text-center h4 mb3">Sdílet stálé parkovací místo</p>
      <Formik
        initialValues={{
          dateFrom: today,
          dateTo: today
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <div className="flex">
            <div className="col-1" />
            <div className="col-5 mr1">
              <DatePickerField name="dateFrom" label="Vyberte termín od" />
            </div>
            <div className="col-5 ml1">
              <DatePickerField name="dateTo" label="Do" />
            </div>
            <div className="col-1" />
          </div>
          <div className="text-center mt3">
            <Submit value="Sdílet" />
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default SharePlacePage;
